<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!auction">
      <span class="loader"></span>
    </span>
    <div v-if="auction" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <auction-view-global :auction="auction" @auctionUpdated="get" />
        </tab-pane>

        <tab-pane title="properties" id="2">
          <span slot="title">
            <i class="ni ni-building"></i>
            {{ $t("COMMON.PROPERTIES") }}
          </span>
          <auction-view-properties :auction="auction" @auctionUpdated="get" />
        </tab-pane>

        <tab-pane title="fees" id="3">
          <span slot="title">
            <i class="ni ni-money-coins"></i>
            {{ $t("COMMON.MRC_FEES") }}
          </span>
          <auction-view-fees :auction="auction" />
        </tab-pane>

        <tab-pane title="bidSteps" id="4">
          <span slot="title">
            <i class="ni ni-settings"></i>
            {{ $t("COMMON.BID_STEPS") }}
          </span>
          <auction-view-bid-steps :auction="auction" />
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <auction-view-logs :auction="auction" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import AuctionViewGlobal from "../partials/AuctionViewGlobal.vue";
import AuctionViewLogs from "../partials/AuctionViewLogs.vue";
import AuctionViewProperties from "../partials/AuctionViewProperties.vue";
import AuctionViewFees from "../partials/AuctionViewFees.vue";
import AuctionViewBidSteps from "../partials/AuctionViewBidSteps.vue";

export default {
  layout: "view-auction-component",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    AuctionViewGlobal,
    AuctionViewLogs,
    AuctionViewProperties,
    AuctionViewFees,
    AuctionViewBidSteps,
  },

  mixins: [],

  props: {
    auctionId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      auction: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("auctions/get", this.auctionId);
        this.auction = this.$store.getters["auctions/auction"];

        this.$emit("auctionChange", this.auction);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
